import BedRequestForm from './bedRequestForm';
import CsmContactTime from './csmContactTime';
import {getConfig} from '../../../../util/configUtil';

const CsmFrom = (props) => {
    const isUHD = getConfig('modules.map.customMap', false);
    const renderForm = () => {
        if (isUHD) return <BedRequestForm {...props}/>;

        return <CsmContactTime {...props}/>;
    };
    return renderForm();
};

export default CsmFrom;